import Help from "./Help";
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";


export default function FormCheckbox(props) {
   var location = props.location ? props.location.toLower() : "right";
   var label = props.label || props.field;
   var field = props.field || props.label;
   var value = props.value || (props.formObject.object || {})[field];
   if (!label) console.error("FormCheckbox requires a field or label property");

   if (!props.formObject.hasOwnProperty("onChange"))
      console.error(props.label + " requires an onChange property defined on the component or at the form level");

   if (!props.formObject.object && !label)
      console.error(props.label + " FormCheckbox requires either a value property or object/field property pair");
   if (
      props.formObject &&
      props.formObject.object &&
      props.formObject.object.constructor === Object &&
      Object.keys(props.formObject.object).length > 0 &&
      !props.formObject.object.hasOwnProperty(field)
   ) {
      console.warn("The object specified does not have a " + field + " property. Creating it.");
   }
   const onChange = (e) => {
      props.formObject.onChange(!value, props.field, "FormCheckbox", e);
   };
   return (
      <div className="field FormCheckbox" onClick={onChange}>
         {location === "left" || location === "above" ? <span className="checkboxLabel">{label}</span> : ""}
         <MdCheckBoxOutlineBlank size={1} className={value ? "hidden" : ""} />
         <MdOutlineCheckBox size={1} className={value ? "" : "hidden"} />
         {location === "right" || location === "below" ? <span className="checkboxLabel">{label}</span> : ""}
         {props.helpid ? <Help id={props.helpid} /> : ""}
      </div>
   );
}
